import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { FaPenToSquare, FaRegTrashCan, FaCheck, FaX } from "react-icons/fa6";
import "../../pages/user/css/Curriculum.css";
import { API_ciudadanos } from "../../config/apiConfig";
import { useAuth } from "../../context/AuthContext";

const Ocupaciones = ({ usuario }) => {
  const { token } = useAuth();

  const [ocupaciones, setOcupaciones] = useState([]);
  const [selectedOcupacion, setSelectedOcupacion] = useState("");
  const [editingIndex, setEditingIndex] = useState(null);
  const [editingValue, setEditingValue] = useState("");

  useEffect(() => {
    if (usuario?.ocupaciones && Array.isArray(usuario.ocupaciones)) {
      setOcupaciones(usuario.ocupaciones);
    }
  }, [usuario]);

  const handleAddOcupacion = async () => {
    const ocupacionTrimmed = selectedOcupacion.trim();
    if (
      ocupacionTrimmed &&
      ocupaciones.length < 3 &&
      !ocupaciones.includes(ocupacionTrimmed)
    ) {
      const nuevasOcupaciones = [...ocupaciones, ocupacionTrimmed];
      setOcupaciones(nuevasOcupaciones);
      setSelectedOcupacion("");

      await actualizarOcupaciones(nuevasOcupaciones);
    }
  };

  const handleDeleteOcupacion = async (index) => {
    const nuevasOcupaciones = ocupaciones.filter((_, i) => i !== index);
    setOcupaciones(nuevasOcupaciones);

    await actualizarOcupaciones(nuevasOcupaciones);
  };

  const handleEditOcupacion = (index) => {
    setEditingIndex(index);
    setEditingValue(ocupaciones[index]);
  };

  const handleSaveEdit = async (index) => {
    const ocupacionTrimmed = editingValue.trim();
    if (ocupacionTrimmed) {
      const nuevasOcupaciones = [...ocupaciones];
      nuevasOcupaciones[index] = ocupacionTrimmed;
      setOcupaciones(nuevasOcupaciones);
      setEditingIndex(null);
      setEditingValue("");

      await actualizarOcupaciones(nuevasOcupaciones);
    }
  };

  const handleCancelEdit = () => {
    setEditingIndex(null);
    setEditingValue("");
  };

  const actualizarOcupaciones = async (ocupacionesActualizadas) => {
    try {
      const res = await fetch(`${API_ciudadanos}/${usuario.userId}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          "x-auth-token": token,
        },
        body: JSON.stringify({ ocupaciones: ocupacionesActualizadas }),
      });

      if (!res.ok) throw new Error("Error al actualizar ocupaciones");

      toast.success("Ocupaciones actualizadas correctamente");
    } catch (error) {
      console.error("❌ Error al actualizar ocupaciones:", error);
      toast.error("No se pudieron guardar los cambios");
    }
  };

  return (
    <div className="ocupaciones caja-verde">
      <h2 className="blanco fondo-verde mayusculas">OCUPACIONES DEMANDADAS</h2>

      <ul className="contenido">
        {ocupaciones.length > 0 ? (
          ocupaciones.map((ocupacion, index) => (
            <li key={index} className="ocupacion-item">
              {editingIndex === index ? (
                <div className="editar-ocupacion between gap-5">
                  <input
                    type="text"
                    value={editingValue}
                    onChange={(e) => setEditingValue(e.target.value)}
                    placeholder="Escribe una ocupación"
                    aria-label="Ocupación"
                  />
                  <div className="check flex gap-5">
                    <button
                      aria-label="Guardar ocupación"
                      className="fondo-blanco verde"
                      onClick={() => handleSaveEdit(index)}
                    >
                      <FaCheck />
                    </button>
                    <button
                      aria-label="Cancelar edición"
                      className="fondo-blanco rojo"
                      onClick={handleCancelEdit}
                    >
                      <FaX />
                    </button>
                  </div>
                </div>
              ) : (
                <div className="editar-cv between capitalize">
                  {ocupacion}
                  <div className="botones-guardar-cancelar">
                    <button
                      aria-label="Editar ocupación"
                      className="fondo-blanco"
                      onClick={() => handleEditOcupacion(index)}
                    >
                      <FaPenToSquare />
                    </button>
                    <button
                      aria-label="Eliminar ocupación"
                      className="fondo-blanco eliminar"
                      onClick={() => handleDeleteOcupacion(index)}
                    >
                      <FaRegTrashCan />
                    </button>
                  </div>
                </div>
              )}
            </li>
          ))
        ) : (
          <li className="texto-defecto">Selecciona de 1 a 3 ocupaciones</li>
        )}
      </ul>

      {ocupaciones.length < 3 && (
        <div className="nueva-edicion-rapida flex gap-10 w-100">
          <input
            type="text"
            value={selectedOcupacion}
            onChange={(e) => setSelectedOcupacion(e.target.value)}
            placeholder="Escribe una ocupación"
            aria-label="Nueva ocupación"
          />
          <button className="boton estrecho" onClick={handleAddOcupacion}>
            Añadir
          </button>
        </div>
      )}
    </div>
  );
};

export default Ocupaciones;
